export default () => ({
  show: false,
  includes: ['address', 'professional', 'covenant'],
  prices: [],
  professional_small_name: null,
  nextStepButtonAddress: [
    {
      icon: '',
      text: 'Cadastrar Local de Atendimento',
      name: 'professional.company.addresses.create',
      action: null
    }
  ]
})



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/index/resources/data.js